import React, { ReactElement } from 'react'

import { useAppSelector } from '../../../store/hooks'

const Component = (): ReactElement => {
  const activePage = useAppSelector(state => state.activepage)

  return (
    <ul className="react-form__steps webform-progress-tracker progress-tracker progress-tracker--center">
      <li
        className={`progress-step ${
          activePage.value === 0 ? 'is-active' : ''
        } ${activePage.value > 0 ? 'is-complete' : ''}`}
        title="Ihr Tarif"
      >
        <span className="progress-marker">1</span>
        <span className="progress-text">
            <span className="progress-title">
              {activePage.value === 2 && (
                <span className="sr-only">Aktuell:</span>
              )}
              Ihr Tarif
            </span>
          </span>
      </li>
     <li
        className={`progress-step ${
          activePage.value === 4 ? 'is-active' : ''
        } ${activePage.value > 4 ? 'is-complete' : ''}`}
        title="Kundendaten"
      >
        <span className="progress-marker">2</span>
        <span className="progress-text step-down">
            <span className="progress-title">
              {activePage.value === 4 && (
                <span className="sr-only">Aktuell:</span>
              )}
              Kundendaten
            </span>
          </span>
      </li>
      <li
        className={`progress-step ${
          activePage.value === 5 ? 'is-active' : ''
        } ${activePage.value > 5 ? 'is-complete' : ''}`}
        title="Stromlieferant"
      >
        <span className="progress-marker">3</span>
        <span className="progress-text step-up">
            <span className="progress-title">
              {activePage.value === 5 && (
                <span className="sr-only">Aktuell:</span>
              )}
              Ihr Wechsel
            </span>
          </span>
      </li>
      <li
        className={`progress-step ${
          activePage.value === 6 ? 'is-active' : ''
        } ${activePage.value > 6 ? 'is-complete' : ''}`}
        title="Erzeugungsanlage"
      >
        <span className="progress-marker">4</span>
        <span className="progress-text step-down">
            <span className="progress-title">
              {activePage.value === 6 && (
                <span className="sr-only">Aktuell:</span>
              )}
              PV-Anlage
            </span>
          </span>
      </li>
      <li
        className={`progress-step ${
          activePage.value === 7 ? 'is-active' : ''
        } ${activePage.value > 7 ? 'is-complete' : ''}`}
        title="Bestellübersicht"
      >
        <span className="progress-marker">5</span>
        <span className="progress-text step-up--last">
            <span className="progress-title">
              {activePage.value === 7 && (
                <span className="sr-only">Aktuell:</span>
              )}
              Auftragsübersicht
            </span>
          </span>
      </li>
    </ul>
  )
}

export default Component
